import { useMemo } from 'react'
import { IntlShape, useIntl } from 'react-intl'
import en from '../../../../../_metronic/i18n/messages/en.json'
import { makeFormat } from './format'

/**
 * Message ids of the dashboard (and of the recurring-event dialogs). The English file is the source
 * of truth: an id that does not exist there is a compile error, so a typo can never reach the UI.
 */
export type MsgId = Extract<
  keyof typeof en,
  `PROFILES_DASHBOARD.${string}` | `EVENTS.RECURRENCE.${string}`
>
export type MsgValues = Record<string, string | number>
export type T = (id: MsgId, values?: MsgValues) => string

const english = en as Record<string, string>

export function makeT(intl: IntlShape): T {
  return (id, values) => intl.formatMessage({ id, defaultMessage: english[id] }, values)
}

export function useT(): T {
  const intl = useIntl()
  return useMemo(() => makeT(intl), [intl])
}

/** Dates, numbers and weekday/month names in the language selected in the application. */
export function useFormat() {
  const { locale } = useIntl()
  return useMemo(() => makeFormat(locale), [locale])
}
